/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Hidden from "@material-ui/core/Hidden";
import CloseIcon from "@material-ui/icons/Close";
import * as moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import InfoIcon from "@material-ui/icons/Info";
import { ThemeActionButton } from "../../../shared/widgets";
import "./EditContractPage.css";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";
import { markEditContractAction } from "../../../redux/action-creators/collectionActionCreator";
import { MessageType } from "../../../Constant";

function EditContractPage(props) {
  const {
    details, initiateNotification, markCollection, closeEditModal, onSuccess,
  } = props;
  const [inputData, setInputData] = useState({});
  useEffect(() => {
    setInputData(details.contract.map((detail) => {
      const editedKey = `edited${detail.type.replace(/^./, (c) => c.toUpperCase())}`;
      const adjustedValue = details[editedKey];

      return {
        contractType: detail.type,
        contractAmount: detail.amount,
        inputAmount: adjustedValue !== undefined ? adjustedValue : detail.amount,
        isAmountNotValid: false,
      };
    }));
  }, [details]);

  const contractDetail = {
    flatFeeShare: "Flat Fee ",
    revenueShare: "Revenue Share",
    bgShare: "Business Guarantee",
    baselineShare: "BaseLine",

  };

  const handleAmountOrCheckboxChange = (value, contract, isAmount, isCheckbox) => {
    if (isAmount) contract.inputAmount = value;
    if (isCheckbox) {
      contract.isAmountNotValid = value;
      contract.inputAmount = value ? 0 : contract.inputAmount;
    }
    setInputData(
      (prevState) => prevState.map((p) => (
        p.contractType === contract.contractType ? Object.assign(p, contract) : p
      )),
    );
  };

  const showNotification = (type, msg) => {
    initiateNotification({
      type,
      message: msg || "Something went wrong",
    });
  };
  const handleSubmitChange = () => {
    if (inputData.find((item) => item.isAmountNotValid === false && item.inputAmount === "")) {
      showNotification(MessageType.ERROR, "Please make the changes in all the field");
      return;
    }
    const selectedData = {
      busNumber: details.busNumber,
      fromDate: parseFloat(moment(new Date(details.fromDate)).format("x")),
    };
    const updates = inputData.map((item) => ({
      type: item.contractType,
      modified_amount: item.inputAmount,
    }));
    markCollection({
      selectedData,
      updates,
    }, "gridLoader")
      .then(() => {
        closeEditModal();
        onSuccess();
      })
      .catch(() => {
        showNotification(MessageType.ERROR, "Something went wrong while saving changes");
      });
  };

  const isFormChanged = () => inputData.some((item) => {
    const editedKey = `edited${item.contractType.replace(/^./, (c) => c.toUpperCase())}`;
    const adjustedValue = details[editedKey];
    const baseValue = adjustedValue !== undefined ? adjustedValue : details[item.contractType];
    return String(item.inputAmount) !== String(baseValue);
  });

  return (
    <Dialog
      onClose={() => closeEditModal()}
      aria-labelledby="customized-dialog-title"
      open
      className="editDialogWrapper"
    >
      <DialogTitle id="customized-dialog-title" onClose={() => closeEditModal()}>
        <div className="modalHeaderWrapper">
          <Hidden only={["sm", "xs"]}>
            <div className="dialogTitle">Contract Details</div>
            <div className="dialogTitle">{`Vehicle - ${details.busNumber}`}</div>
          </Hidden>
          <Hidden only={["lg", "xl", "md"]}>
            <div className="dialogTitle">{`${details.busNumber} Details`}</div>
          </Hidden>
          <div className="btnWrapper">
            <div
              role="button"
              className="closeIcon"
              onClick={() => closeEditModal()}
              onKeyDown={() => { /* onKeyDown */ }}
              tabIndex="0"
              aria-label="close"
            >
              <CloseIcon />
            </div>
          </div>
        </div>
      </DialogTitle>
      <DialogContent dividers className="detailWrapper">
        {inputData.length === 0 && (
          <div className="error-no-data">
            No data on contract to show
          </div>
        )}
        {inputData
                    && inputData.length > 0
                    && (
                      <>
                        <div className="sub-heading">
                          <span>Terms</span>
                        </div>
                        <div className="sub-container">
                          <div className="detailrow">
                            <div>Period</div>
                            {" "}
                            <div>
                              {`${moment(details.fromDate).format("DD MMM YYYY")}`}
                            </div>
                          </div>
                        </div>

                        {
                          inputData.map((raw, index) => {
                            const labelId = `transfer-list-all-item-${index}-label`;
                            const editedKey = `edited${raw.contractType.replace(/^./, (c) => c.toUpperCase())}`;
                            const editedDateKey = `${raw.contractType.replace(/^./, (c) => c.toLowerCase())}EditDate`;
                            const oldValue = details[raw.contractType];
                            const editedValue = details[editedKey];
                            const editedDatevalue = details[editedDateKey];
                            return (
                              <div key={index} className="edit-contract-page">
                                <div className="sub-heading">
                                  <span>Commercials</span>
                                </div>
                                <div className="sub-container">
                                  <div className="container-wrapper">
                                    <div className="contract-detail">
                                      {(editedValue !== undefined && oldValue !== undefined
                                      && editedValue !== oldValue)
                                        ? (
                                          <div className="value-container">
                                            <div className="row-container">
                                              <div>Contract Type</div>
                                              <div className="value">Contract Amount</div>
                                            </div>
                                            <div className="row-container font-wt-700">
                                              <div>{`Original ${contractDetail[raw.contractType]}`}</div>
                                              <div className="value">{oldValue}</div>
                                            </div>
                                            <div className="row-container font-wt-700">
                                              <div>{`Adjusted ${contractDetail[raw.contractType]}`}</div>
                                              <div className="value">{editedValue}</div>
                                            </div>
                                          </div>
                                        ) : (
                                          raw.contractType && (
                                            <div className="value-container">
                                              <div className="row-container">
                                                <div>Contract Type</div>
                                                <div className="value">Contract Amount</div>
                                              </div>
                                              <div className="row-container font-wt-700">
                                                <div>{contractDetail[raw.contractType]}</div>
                                                <div className="value">{raw.contractAmount}</div>
                                              </div>
                                            </div>
                                          )
                                        )}
                                    </div>

                                    <div>
                                      <div className="row-container">
                                        <div className="checkbox-container">
                                          <Checkbox
                                            onChange={(e) => {
                                              handleAmountOrCheckboxChange(
                                                e.target.checked,
                                                raw,
                                                false,
                                                true,
                                              );
                                            }}
                                            inputProps={{ "aria-labelledby": labelId }}
                                            style={{ padding: "0px" }}
                                          />
                                          Select the checkbox to make the amount 0
                                        </div>
                                        <div className="contract-number">
                                          <input
                                            type="number"
                                            className={`form-control ${raw.isAmountNotValid === false && raw.inputAmount === "" ? "red-input-block" : ""}`}
                                            disabled={raw.isAmountNotValid ? "disabled" : ""}
                                            placeholder="Amount"
                                            onChange={(e) => {
                                              handleAmountOrCheckboxChange(
                                                e.target.value,
                                                raw,
                                                true,
                                                false,
                                              );
                                            }}
                                            value={raw.inputAmount}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {editedValue !== undefined && oldValue !== undefined
                                  && editedValue !== oldValue && (
                                    <div className="edit-message-container">
                                      <div className="edit-message">
                                        <InfoIcon sx={{ fontSize: "16px" }} />
                                        {`The ${contractDetail[raw.contractType]} was adjusted from ₹${oldValue} to ₹${editedValue} on ${moment(editedDatevalue).format("DD MMM YYYY")}.`}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })
                        }
                        <div className="footer-submit-btn sub-heading">
                          <ThemeActionButton
                            onClick={() => handleSubmitChange()}
                            buttonText="Submit"
                            disabled={!isFormChanged()}
                          />
                        </div>
                      </>
                    )}
      </DialogContent>

    </Dialog>
  );
}
const mapDispatchToProps = (dispatch) => ({
  initiateNotification: (value) => (dispatch(setNotificationMessage(value))),
  markCollection: (params, loaderScope) => new Promise((resolve, reject) => {
    dispatch(markEditContractAction(params, loaderScope))
      .then(resolve)
      .catch(reject);
  }),
});

export default connect(null, mapDispatchToProps)(EditContractPage);
